<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DlTh5N/tc-custom/9781504003995.jpg?1705634330466" alt="This image is the cover for the book Blue Herring Mystery, The Ellery Queen Jr. Mystery Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blue Herring Mystery, The Ellery Queen Jr. Mystery Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>An ancient whaling journal sets Djuna on course for buried treasure</b><br/><br/> When old Captain Beekman was on his deathbed, he turned to his daughter and muttered, “Lift the blue herring.” It’s a cryptic piece of family lore—until the day Djuna pays a visit to the old captain’s house. Inspecting the ship’s log from Captain Beekman’s final sailing voyage, the brilliant young sleuth notices something no one else ever has. A page has been torn out—and it holds the key to an adventure.<br/>  <br/> Could the missing page have to do with a long-buried treasure? Where does the blue herring fit in? With his scrappy terrier, Champ, by his side, Djuna will unravel the mystery and decode the captain’s last words once and for all.<br/>  <br/> Ellery Queen is one of the world’s finest detectives, but his adventures are nothing compared to the Ellery Queen Jr. Mystery Stories. Join Queen’s apprentice, Djuna, and his trusty Scottie, Champ, on adventures filled with danger, suspense, and thrills.<br/>  <br/><i>The Blue Herring Mystery is the eighth book in the Ellery Queen Jr. Mystery Stories, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellery Queen
      </h2>
      
      <p class="authorDescription body article">Ellery Queen was a pen name created and shared by two cousins, Frederic Dannay (1905&ndash;1982) and Manfred B. Lee (1905&ndash;1971), as well as the name of their most famous detective. Born in Brooklyn, they spent forty-two years writing, editing, and anthologizing under the name, gaining a reputation as the foremost American authors of the Golden Age &ldquo;fair play&rdquo; mystery.<BR /> Although eventually famous on television and radio, Queen&rsquo;s first appearance came in 1928, when the cousins won a mystery-writing contest with the book that would eventually be published as <I>The Roman Hat Mystery</I>. Their character was an amateur detective who uses his spare time to assist his police inspector uncle in solving baffling crimes. Besides writing the Queen novels, Dannay and Lee cofounded <I>Ellery Queen&rsquo;s Mystery Magazine</I>, one of the most influential crime publications of all time. Although Dannay outlived his cousin by nine years, he retired Queen upon Lee&rsquo;s death.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?020c1a51